// 请求ab test
import { request } from 'root/common/request';
import config from 'root/common/config/config';
import storage from 'root/common/util/storage';
import { resolveApi } from 'root/common/util/requestHelper';
import env from '@/common/util/env';
import { getMiniEnvOfKey } from 'root/common/util/miniEnv';
import { setGioVisitorForABTest } from 'root/common/gio/peopleVar';
let promise = null;

// 10分钟超时
const timeout = 10 * 60 * 1000;
let isFetching = false;

export function fetchABTest() {
    const phpUserId = storage.get(storage.keys.memberId, { bare: true });
    // 小程序下如果有虚拟memberId就用虚拟的
    const virtuaMemberId = getMiniEnvOfKey('virtuaMemberId');
    if (!phpUserId && !virtuaMemberId) return Promise.resolve(false);
    return resolveApi(
        request({
            url: config.api.getAllABtest,
            method: 'get',
            params: {
                phpUserId: env.isWechatMini && virtuaMemberId ? virtuaMemberId : phpUserId,
            },
            isNeedLoading: false,
            timeout: 6000,
        }),
        {
            code: 0,
        }
    );
}

export default async function fetchABTestIfNeed(t = timeout) {
    if (isFetching) {
        return promise;
    }
    const obj = storage.get(storage.keys.abtest);
    if (obj && obj.time > Date.now() - t) return;
    try {
        isFetching = true;
        promise = fetchABTest();
        const data = await promise;
        if (data) {
            storage.set(storage.keys.abtest, { data, time: Date.now() });
            // abtest相关gio用户变量
            setGioVisitorForABTest(data);
        }
        isFetching = false;
        promise = null;
    } catch (error) {
        console.log(error);
        isFetching = false;
        promise = null;
    }
}

export async function fetchABTestH5IfNeed(t = timeout) {
    if (isFetching) {
        return promise;
    }
    const obj = storage.get(storage.keys.h5Abtest);
    if (obj && obj.time > Date.now() - t) return;
    try {
        isFetching = true;
        promise = fetchABTest();
        const data = await promise;
        if (data) {
            storage.set(storage.keys.h5Abtest, { data, time: Date.now() });
            // abtest相关gio用户变量
            setGioVisitorForABTest(data);
        }
        isFetching = false;
        promise = null;
    } catch (error) {
        console.log(error);
        isFetching = false;
        promise = null;
    }
}
